// extracted by mini-css-extract-plugin
module.exports = {"checkmarkIcon":"JournalCardHydrationContainer_checkmarkIcon___9o21","fadeOut":"JournalCardHydrationContainer_fadeOut__2H6XF","fadeIn":"JournalCardHydrationContainer_fadeIn__1t60q"};